import { render } from "./ViewAddTypes.vue?vue&type=template&id=5ec71477"
import script from "./ViewAddTypes.vue?vue&type=script&lang=js"
export * from "./ViewAddTypes.vue?vue&type=script&lang=js"

import "./ViewAddTypes.vue?vue&type=style&index=0&id=5ec71477&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__